export default [
  {
    action: `read`,
    subject: `dashboard-network-monitoring`,
  },
  {
    action: `manage`,
    subject: `client`,
  },
  {
    action: `manage`,
    subject: `useraccount`,
  },
  // {
  //   action: `manage`,
  //   subject: `config`,
  // },
  {
    action: `manage`,
    subject: `tools`,
  },
  {
    action: `manage`,
    subject: `plumm-calculator`,
  },
  {
    action: `super`,
    subject: `nawala`,
  },
];
